'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/supports-color/browser.js
// module id = 620
// module chunks = 0